module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan g‚riatrie.faf548ea.svg";